export default __webpack_public_path__ + "static/media/illustration-united-kingdom.70381d66.svg";